import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Login } from './components/Auth';
import { Dashboard } from './components/Dashboard';
import { AuditExplorer } from './components/AuditExplorer';
import { GapList } from './components/GapList';
import { CompetitiveIntel } from './components/CompetitiveIntel';
import { SourceOfTruth } from './components/SourceOfTruth';
import { ReportBuilder } from './components/ReportBuilder';
import { Settings } from './components/Settings';
import { Analysis } from './components/Analysis';
import { Layout } from './components/Layout';
import { VisibilityScore } from './components/VisibilityScore/VisibilityScore';

// Content Library Tool
import {
  ContentDashboard,
  Connectors,
  Records,
  AIReadiness,
  Governance,
  PublishToAI,
  SyncLog
} from './components/ContentLibrary';

// Brand Agent Tool
import {
  AgentDashboard,
  AgentConfiguration,
  InteractionLog,
  SalesIntent,
  QueryMonitor,
  Guardrails,
  MCPEndpoints,
  AuditLog
} from './components/BrandAgent';

function App() {
  const { user, loading, error, signIn } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={signIn} error={error} />;
  }

  return (
    <Router>
      <Layout user={user}>
        <Routes>
          {/* Audit Tool */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/visibility-score" element={<VisibilityScore />} />
          <Route path="/audit-explorer" element={<AuditExplorer />} />
          <Route path="/gaps" element={<GapList />} />
          <Route path="/competitive" element={<CompetitiveIntel />} />
          <Route path="/source-of-truth" element={<SourceOfTruth />} />
          <Route path="/reports" element={<ReportBuilder />} />
          <Route path="/analysis" element={<Analysis />} />
          <Route path="/settings" element={<Settings />} />

          {/* Content Library Tool */}
          <Route path="/content-library" element={<ContentDashboard />} />
          <Route path="/content-library/connectors" element={<Connectors />} />
          <Route path="/content-library/records" element={<Records />} />
          <Route path="/content-library/ai-readiness" element={<AIReadiness />} />
          <Route path="/content-library/governance" element={<Governance />} />
          <Route path="/content-library/publish" element={<PublishToAI />} />
          <Route path="/content-library/sync-log" element={<SyncLog />} />

          {/* Brand Agent Tool */}
          <Route path="/brand-agent" element={<AgentDashboard />} />
          <Route path="/brand-agent/config" element={<AgentConfiguration />} />
          <Route path="/brand-agent/interactions" element={<InteractionLog />} />
          <Route path="/brand-agent/sales-intent" element={<SalesIntent />} />
          <Route path="/brand-agent/query-monitor" element={<QueryMonitor />} />
          <Route path="/brand-agent/guardrails" element={<Guardrails />} />
          <Route path="/brand-agent/mcp-endpoints" element={<MCPEndpoints />} />
          <Route path="/brand-agent/audit-log" element={<AuditLog />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
